import { render, staticRenderFns } from "./RecentAssets.vue?vue&type=template&id=149428a6&scoped=true"
import script from "./RecentAssets.vue?vue&type=script&lang=js"
export * from "./RecentAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149428a6",
  null
  
)

export default component.exports